import { createContext, useContext } from 'react';

export const ProgramContext = createContext();

export const useProgramContext = () => useContext(ProgramContext);

export default ProgramContext;
